// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__3lj_O","icon":"SortAdornment_icon__gCYm9","up":"SortAdornment_up__Ce5hF","down":"SortAdornment_down__3DpQS","active":"SortAdornment_active__1GlgA"};